import { Button, ButtonSizesEnum, ButtonThemesEnum } from '@propertyfinder/button';
import { IconBin } from '@propertyfinder/icons';
import { FunctionComponent, h } from 'preact';
import { useCallback, useRef } from 'preact/hooks';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { PropertyReportUploadTemplatePropsInterface } from 'common/module/property-report/upload/template-props.interface';

export const PropertyReportUploadTemplate: FunctionComponent<PropertyReportUploadTemplatePropsInterface> = ({
  onUploadFile,
  title,
  onDocumentClear,
  file,
  fileInputRef,
  onBlurFile,
}) => {
  const elementRef = useRef<HTMLInputElement>(null);
  const handleClick = useCallback(() => {
    fileInputRef ? fileInputRef.current.click() : elementRef.current.click();
  }, [elementRef]);
  const handleChange = useCallback(
    (event: Event) => {
      onUploadFile(event);
    },
    [onUploadFile]
  );
  const handleRemove = useCallback(() => {
    onDocumentClear();
  }, []);
  const displayTitle = (file: File): string => {
    return `${file.name}`;
  };
  return (
    <div>
      <span className='property-report-2--uploader-title'>{title}</span>
      {file ? (
        <div className='property-report-2__uploaded-box row-center'>
          <div className='property-report-2__uploaded-box--info row-center'>
            <img src={__('assets/common/file-uploaded.svg')} />
            <span>{displayTitle(file)}</span>
          </div>

          <Button
            theme={ButtonThemesEnum.GHOST}
            className='property-report-2__uploaded-box-action'
            onClick={handleRemove}
            size={ButtonSizesEnum.SMALL}
            type={'button'}
            htmlAttributes={{
              'data-testid': `remove-button-${title.toLowerCase().split(' ').join('-')}`,
            }}
          >
            <IconBin />
          </Button>
        </div>
      ) : (
        <div className='property-report-2__uploader-box row-center'>
          <div className='row-center'>
            <img src={__('assets/common/file-upload.svg')} />
            <span className='property-report-2__uploader-box--placeholder'>
              {i18nTranslate('ReportProperty_ClickToUpload')}
            </span>
          </div>
          <input
            type='file'
            ref={fileInputRef ? fileInputRef : elementRef}
            className='property-report-2__uploader-box-input'
            name='cmt-file'
            data-testid={`file-uploader-${title}`}
            onChange={(event): void => handleChange(event)}
            onBlur={onBlurFile}
          />

          <Button
            theme={ButtonThemesEnum.PRIMARY}
            className='property-report-2__uploader-box-action'
            onClick={handleClick}
            size={ButtonSizesEnum.SMALL}
            htmlAttributes={{
              name: 'upload',
            }}
            type={'button'}
          >
            {i18nTranslate('ReportProperty_UploadCta')}
          </Button>
        </div>
      )}
    </div>
  );
};
